import { SplitButton } from "primereact/splitbutton";
import * as React from "react";
import { useTranslation } from "react-i18next";
import "./PrwcSplitButton.scss";

const PrwcSplitButton = (props: any) => {
  const { model, labelKey, onClick } = props;
  const { t } = useTranslation();

  return (
    <div className="prw-split-button">
      <SplitButton
        label={t(labelKey)}
        model={model}
        onClick={onClick}
        menuClassName="prw-split-button top-1/4 left-10 w-16"
      ></SplitButton>
    </div>
  );
};

export default PrwcSplitButton;
